<script>
import GalleryInfo from '../../components/galleryInfo.vue';
import Length from '../../components/length.vue';
import Loading from '../../components/loading.vue';

export default {
    name: "join",
    data() {
        return {
            isLoading: false,
            detail: {},
            weeks: ['日', '一', '二', '三', '四', '五', '六'],
            startTime: null,
            endTime: null,
            year: null,
            month: null,
            // day: null,
            // 当月天数
            days: null,
            // 当月第一天周几
            firstDayWeek: null,
            // 当月最后一天周几
            lastDayWeek: null,
            chooseDate: null,
            // 成人票
            ticketNum: 1,
            // 早鸟票
            earlyNum: 0,
        };
    },
    computed: {
        isCanPrev() { 
            if (this.startTime) { 
                return this.year > this.startTime[0] || this.year == this.startTime[0] && this.month > this.startTime[1]
            } else {
                return false
            }
        },
        isCanNext() { 
            if (this.endTime) { 
                return this.year < this.endTime[0] || this.year == this.endTime[0] && this.month < this.endTime[1]
            } else {
                return false
            }
        },
        isDisabled() { 
            return (index) => {
                return (this.year == this.startTime[0] && this.month == this.startTime[1] && index + 1 < this.startTime[2]) || 
                (this.year == this.endTime[0] && this.month == this.endTime[1] && index + 1 > this.endTime[2])
            }
        },
    },
    components: {
        GalleryInfo,
        Loading,
        Length
    },
    mounted() {
        this.getData();
    },
    destroyed() {},
    watch: {
        year: 'init',
        month: 'init',
    },
    methods: {
        getData() {
            this.isLoading = true;
            this.$store.dispatch('getGalleryDetail', {
                id: this.$route.query.id
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.detail = result.data;
                    // 年月日
                    let date = this.startTime = this.detail.start_time.split('-').map(v => parseInt(v));
                    this.endTime = this.detail.end_time.split('-').map(v=> parseInt(v));
                    this.year = date[0];
                    this.month = date[1];
                    // this.day = date[2];
                    // 日历
                    this.init();
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        // 初始化日历
        init() {
            // 第一天周几
            this.firstDayWeek = new Date(this.year, this.month - 1, 1).getDay();
            // 这个月最后一天
            let lastDate = new Date(this.year, this.month, 0);
            this.days = lastDate.getDate(); // 这个月天数
            this.lastDayWeek = lastDate.getDay(); //最后一天周几
        },
        prevMonth() {
            if (this.month <= 0) { 
                this.year--;
                this.month = 11;
            } else {
                this.month--;
            }
        },
        nextMonth() {
            if (this.month >= 11) { 
                this.year++;
                this.month = 0;
            } else {
                this.month++;
            }
        },
        // 选择日期
        choose(day) {
            this.chooseDate = [this.year, this.month, day];
        },
        // 提交
        submit() {
            if (!this.chooseDate) { 
                this.$showToast({ text: '请选择日期' });
                return;
            }
            return;
            this.$showLoading();
            this.$store.dispatch('joinExhibition', {
                exhibition_id: this.$route.query.id,
                data: this.chooseDate,
                count: this.ticketNum,
            }).then((result) => {
                this.$hideLoading();
                if (result.code == 100) {
                    this.$showToast({ text: '订单已提交' });
                    // 未支付为 0，已支付（免费）为 1
                    if (result.data.is_pay == 0) {
                        // 跳转支付
                        this.$router.push({
                            path: '/order',
                            query: {
                                code: result.data.order_code
                            }
                        })
                    } else if (result.data.is_pay == 1) {
                        // 已支付（免费），跳转支付成功页面
                        this.$router.push({
                            path: '/orderSuccess',
                            query: {
                                code: result.data.order_code
                            }
                        })
                    }
                } else if (result.code == 90) {
                    this.$showToast({ text: '登录凭证已失效' });
                    this.toLogin();
                } else if (result.code == 101) {
                    this.$showToast({ text: '展览已结束' });
                }
            }).catch((err) => {
                this.$hideLoading();
                this.$showToast({ text: '订单提交失败' });
            });
        },
        // 跳转登录
        toLogin() { 
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            })
        },
    },
};
</script>

<template>
    <div class="join">
        <div class="layout_body">
            <!-- banner -->
            <div class="banner">
                <div class="layout_bg" :style="`background-image: url(${detail.banner});`"></div>
            </div>
            <!--  -->
            <div class="layout_main">
                <div class="layout_content" v-if="isLoading">
                    <Loading/>
                </div>
                <div class="layout_content" v-else>
                    <p class="title">选择日期</p>
                    <div class="calendar">
                        <div class="top flex justify_between align_center">
                            <div class="btn_prev" :class="{disabled: !isCanPrev}" @click="prevMonth"></div>
                            <p class="date">{{ year }}年{{ month }}月</p>
                            <div class="btn_next" :class="{disabled: !isCanNext}" @click="nextMonth"></div>
                        </div>
                        <div class="weeks flex">
                            <div class="item" v-for="(item, index) in weeks" :key="index">星期{{ item }}</div>
                        </div>
                        <div class="list flex flex_wrap">
                            <!-- 上个月 -->
                            <div class="item other" v-for="(item, index) in firstDayWeek" :key="`prev${index}`"></div>
                            <!-- 这个月 -->
                            <div class="item" :class="{
                                disabled: isDisabled(index),
                                // is_today: year == today[0] && month == today[1] && index + 1 == today[2],
                                check: chooseDate ? (chooseDate[0] == year && chooseDate[1] == month && chooseDate[2] == index + 1) : false
                            }" 
                            v-for="(item, index) in days" :key="index"
                            @click="choose(index + 1)">{{ index + 1 }}</div>
                            <!-- 下个月 -->
                            <div class="item other" v-for="(item, index) in 6 - lastDayWeek" :key="`next${index}`"></div>
                        </div>
                    </div>
                    <p class="title">选择门票</p>
                    <div class="ticket">
                        <div class="item">
                            <p class="name">成人</p>
                            <p class="price" v-if="detail.price == '0.00'">免费</p>
                            <p class="price" v-else>RMB {{ detail.price }}</p>
                            <Length min="1" v-model="ticketNum"/>
                        </div>
                        <!-- <div class="item">
                            <p class="name">早鸟票</p>
                            <p class="price" v-if="detail.early_price == '0.00'">免费</p>
                            <p class="price" v-else>RMB {{ detail.early_price }}</p>
                            <Length min="0" v-model="earlyNum"/>
                        </div> -->
                    </div>
                    <div class="btn_join layout_flex_center" @click="submit">立即预约</div>
                </div>
            </div>
        </div>
        <GalleryInfo/>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.3rem;
    }
}
.layout_content{
    @media only screen and (max-width: 750px) {
        padding: .3rem 0;
    }
}
.title{
    font-size: .26rem;
    text-align: center;
    margin-bottom: .3rem;
    @media only screen and (max-width: 750px) {
        font-size: .3rem;
    }
}
.btn_join{
    font-size: .20rem;
    width: 3rem;
    height: .6rem;
    border: 1px solid #999;
    margin: .5rem auto 0;
    cursor: pointer;
    @media only screen and (max-width: 750px) {
        width: 100%;
        height: .8rem;
        font-size: .26rem;
    }
}
.calendar{
    margin-bottom: .5rem;
    .top{
        margin-bottom: .2rem;
        .date{
            flex: 1;
            font-size: .24rem;
            text-align: center;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
        .btn_prev,
        .btn_next{
            width: .4rem;
            height: .4rem;
            cursor: pointer;
            position: relative;
            @media only screen and (max-width: 750px) {
                width: .5rem;
                height: .5rem;
            }
            &.disabled{
                pointer-events: none;
                opacity: .5;
            }
            &::after{
                content: "";
                width: .1rem;
                height: .1rem;
                border-top: 1px solid #333;
                border-right: 1px solid #333;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
        }
        .btn_prev{
            &::after{
                transform: translate(-50%, -50%) rotate(-135deg);
            }
        }
    }
    .weeks{
        border: 1px solid #d9d9d9;
        .item{
            width: 14.286%;
            height: .8rem;
            line-height: .8rem;
            font-size: .18rem;
            text-align: center;
            border-right: 1px solid #d9d9d9;
            &:last-child{
                border-right: none;
            }
            @media only screen and (max-width: 750px) {
                height: .5rem;
                line-height: .5rem;
            }
        }
    }
    .list{
        border: 1px solid #d9d9d9;
        border-top: none;
        .item{
            width: 14.286%;
            height: 1rem;
            line-height: 1rem;
            font-size: .18rem;
            text-align: center;
            border-top: 1px solid #d9d9d9;
            border-right: 1px solid #d9d9d9;
            cursor: pointer;
            @media only screen and (max-width: 750px) {
                height: .8rem;
                line-height: .8rem;
            }
            &:nth-of-type(1),
            &:nth-of-type(2),
            &:nth-of-type(3),
            &:nth-of-type(4),
            &:nth-of-type(5),
            &:nth-of-type(6),
            &:nth-of-type(7){
                border-top: none;
            }
            &:nth-of-type(7n){
                border-right: none;
            }
            &.disabled{
                color: #d9d9d9;
                pointer-events: none;
            }
            &.check{
                background: #000;
                color: #fff;
            }
        }
    }
}
.ticket{
    border-top: 1px solid #d9d9d9;
    .item{
        border-bottom: 1px solid #d9d9d9;
        height: 1rem;
        padding: 0 .3rem;
        display: flex;
        align-items: center;
        gap: .3rem;
        @media only screen and (max-width: 750px) {
            padding: 0 .2rem;
            gap: .2rem;
        }
        .name{
            font-size: .26rem;
            flex: 1;
        }
        .price{
            font-size: .18rem;
            width: 2rem;
            text-align: center;
            color: #666;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
    }
}
</style>